import { Flex } from 'uikit'
import styled from 'styled-components'

const ImgLoading = styled.img`
  width: 90px;
`

export default function LoadingSection() {
  return (
    <Flex justifyContent="center" width="100%" alignItems="center" height="404px">
      <ImgLoading src="/images/mojito-games-loading-trans.webp" />
    </Flex>
  )
}
